import React from "react";
import SignOut from "../../SignOut/SignOut";
const MobileUserSignOut = () => {
  return (
    <>
      <div className="offcanvasWidgetArea">
        <div className="offCanvasWidgetSocial">
          <SignOut isColor={false}/>
        </div>
      </div>
    </>
  );
};

export default MobileUserSignOut;
